$("label[for*='MDF']").css("background-color", "yellow");
$("label[for*='1%2F8%22+MDF']").css("background-color", "yellow");
//$("label[for*='1%2F4%22+MDF']").css("background-color", "yellow");
//$("label[for*='1%2F16%22+MDF']").css("background-color", "yellow");
$("label[for*='Black+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F8%22+Black+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F8%E2%80%9D+Black+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F16%22+Black+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F4%22+Black+Acrylic']").css("background-color", "yellow");
$("label[for*='Red+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F8%22+Red+Acrylic']").css("background-color", "yellow");
$("label[for*='1%2F8%E2%80%9D+Red+Acrylic']").css("background-color", "yellow");
$("label[for*='Yellow+Acrylic']").css("background-color", "yellow");
$("label[for*='Neon+Yellow+Acrylic']").css("background-color", "");
//$("label[for*='1%2F8%E2%80%9D+Yellow+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F8%22+Yellow+Acrylic']").css("background-color", "yellow");
$("label[for*='Green+Acrylic']").css("background-color", "yellow");
$("label[for*='Neon+Green+Acrylic']").css("background-color", "");
//$("label[for*='1%2F8%E2%80%9D+Green+Acrylic']").css("background-color", "yellow");
//$("label[for*='1%2F8%22+Green+Acrylic']").css("background-color", "yellow");
$("label[for*='0.01%22+Clear+Flex']").css("background-color", "yellow");
//$("label[for*='0.01%22+White+Flex']").css("background-color", "yellow");
$("label[for*='White+Flex']").css("background-color", "yellow");
$("label[for*='Peel+and+Stick+Clear+Flex']").css("background-color", "yellow");
$("label[for*='Peel+and+Stick+Mirror']").css("background-color", "yellow");
$("label[for*='Laser+Safe+Vinyl']").css("background-color", "yellow");
$("label[for*='Leather']").css("background-color", "yellow");
$("label[for*='0.03%22+Veneer+with+3M+backing']").css("background-color", "yellow");
$("label[for*='0.01%22+FROSTED+Clear+Flex']").css("background-color", "yellow");
$("label[for*='Smokestacked+Core+Plywood']").css("background-color", "yellow");

$("label[for*='12x19%22+MDF+Core']").css("background-color", "white");
$("label[for*='12x19%22+Smokestacked+Core']").css("background-color", "white");

$( "label.variant__label" ).each(function( index ) {
  //console.log( index + ": " + $( this ).text() );

  var labelText = $( this ).text();
  if (labelText.toLowerCase().indexOf("material") >= 0){
    if (labelText.toLowerCase().indexOf("core") >= 0){
    }
    else{
      $( this ).text("Material (Core)");      
    }
  }
});

//$('div.grid__item div a').attr('href','');

//$("label[for*='1%2F8%22+Gold+Mirrored+Acrylic']").addClass("disabled");
//console.log("Gold+Mirrored+Acrylic");

//$("label[for*='CartTerms']").html('This is a test');

var currentD = new Date();  

const saleDate = new Date();
saleDate.setFullYear(2025, 9, 29); // Oct 27 - Please note that month counts from 0. December is month 11
saleDate.setHours(21,0,0); // 9.00 pm

const saleDateTwo = new Date();
saleDateTwo.setFullYear(2025, 10, 3); // Nov 3 - Please note that month counts from 0. December is month 11
saleDateTwo.setHours(21,0,0); //9.00 pm

const saleDateThree = new Date();
saleDateThree.setFullYear(2025, 10, 5); // Nov 5 - Please note that month counts from 0. December is month 11
saleDateThree.setHours(21,0,0); // 9.00 pm

const saleDateFour = new Date();
saleDateFour.setFullYear(2025, 9, 15); // Sept 15 - Please note that month counts from 0. December is month 11
saleDateFour.setHours(21,0,0); // 9.00 pm

const saleDateFive = new Date();
saleDateFive.setFullYear(2025, 9, 17); // Sept 17 - Please note that month counts from 0. December is month 11
saleDateFive.setHours(21,0,0); // 9.00 pm

const saleDateSix = new Date();
saleDateSix.setFullYear(2025, 9, 22); // Sept 22 - Please note that month counts from 0. December is month 11
saleDateSix.setHours(21,0,0); // 9.00 pm

const saleDateSeven = new Date();
saleDateSeven.setFullYear(2025, 10, 1); // Oct 1 - Please note that month counts from 0. December is month 11
saleDateSeven.setHours(21,0,0); // 9.00 pm

var field = 'q';
var inspfield = 'inspiration';
var url = window.location.href;
const searchParams = new URLSearchParams(window.location.search);
const q = searchParams.get('q')
const insp = searchParams.get('inspiration')

  if( window.location.href.indexOf("2025-misfit-calendars" ) > -1) {
  	$(".grid-product__price").css("display", "none");
    $(".collection-filter").css("display", "none");
  }

    if( window.location.href.indexOf("curated-collection" ) > -1) {
  	$(".sezzle-checkout-button-wrapper").css("display", "none");
    $(".sezzle-button-text").css("display", "none");
    $(".uwl-btn-position").css("display", "none");
    $(".ps__widget_container").css("display", "none");
    $(".product-block .product-block").css("display", "none");
    $(".store-availability .store-availability ").css("display", "none");
  }


//Sunday
if(currentD < saleDate){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    $('div[data-product-handle="misfit-1-8-patternply-color-core-acrylic"] .grid-product__tag--sold-out').html('Available 10/27 @ 9:00PM EST');
    //$('div[data-product-handle="misfit-1-8-patternply-white-acrylic"] .grid-product__tag--sold-out').html('Available 10/8 @ 9:00PM EST');
  }
} 
//Monday
if(currentD < saleDateTwo){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    $('div[data-product-handle="copy-of-misfit-1-8-ecobirch"] .grid-product__tag--sold-out').html('Available 11/3 @ 9:00PM EST<br>This is Diode Friendly');
    //$('div[data-product-handle="misfit-patternply-laser-safe-vinyl"] .grid-product__tag--sold-out').html('Available 10/15 @ 9:00PM EST');
  }
}
if(currentD < saleDateThree){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    $('div[data-product-handle="misfit-transparent-clear-flex"] .grid-product__tag--sold-out').html('Available 11/5 @ 9:00PM EST');
  }
}
//Tuesday
if(currentD < saleDateFour){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    //$('div[data-product-handle="misfit-aromatic-cedar"] .grid-product__tag--sold-out').html('Available 11/26 @ 3:00PM EST<br>This is Diode Friendly');
    //$('div[data-product-handle="misfit-baltic-birch"] .grid-product__tag--sold-out').html('Available 11/26 @ 3:00PM EST<br>This is Diode Friendly');
    $('div[data-product-handle="misfit-1-8-smokesub-bundle"] .grid-product__tag--sold-out').html('Available 9/15 @ 9:00PM EST<br>This is Diode Friendly');
    $('div[data-product-handle="misfit-walnut"] .grid-product__tag--sold-out').html('Available 9/15 @ 9:00PM EST');
  }
}
if(currentD < saleDateFive){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    $('div[data-product-handle="misfit-1-8-patternply-mdf-copy"] .grid-product__tag--sold-out').html('Available 9/17 @ 9:00PM EST<br>This is Diode Friendly');
  }
}
//Wednesday
if(currentD < saleDateSix){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    $('div[data-product-handle="misfit-patternply®-1-8-glitter"] .grid-product__tag--sold-out').html('Available 10/22 @ 9:00PM EST');
    $('div[data-product-handle="misfit-patternply®-1-8-mirror-and-glitter-acrylic-mix"] .grid-product__tag--sold-out').html('Available 10/22 @ 9:00PM EST');
    //$('div[data-product-handle="misfit-3m-backed-veneers-assorted-light-woods"] .grid-product__tag--sold-out').html('Available 11/27 @ 9:00PM EST<br>This is Diode Friendly');
    //$('div[data-product-handle="misfit-19-x-24-patternply®-1-8-clear-acrylic"] .grid-product__tag--sold-out').html('Available 11/27 @ 9:00PM EST');
  }
}
if(currentD < saleDateSeven){
  if( window.location.href.indexOf("misfits" ) > -1 || (q != null && q.toLowerCase().includes('misfit'))) {
    $('div[data-product-handle="misfit-patternply®-transparent-1-8"] .grid-product__tag--sold-out').html('Available 10/1 @ 9:00PM EST');
  }
}

//$('div[data-product-handle="1-8-ecobirch"] .grid-product__tag--sold-out').html('Restocking on 11/13');
$('div[data-product-handle="2025-holiday-free-shipping"] .grid-product__tag--sold-out').html('Available 8/23');

//Updated Code

$(document).ready(function () {
  // Cache selectors
  const $select0 = $("select[id^='SingleOptionSelector-template--'][id$='-option-0']");
  const $select1 = $("select[id^='SingleOptionSelector-template--'][id$='-option-1']");
  const $select2 = $("select[id^='SingleOptionSelector-template--'][id$='-option-2']");
  const $btn = $("#btnShowDiodeFriendly");
  const $txt = $("#txtShowDiodeFriendly");
  let $detachedOptions1;
  let $detachedOptions2;
  let isShowingDiodeFriendly = false;

  // Hide option-1 and option-2 initially
  if(insp != null && insp.toLowerCase().includes('true')) {
    //console.log('inspiration page link');
    $select0.prepend('<option value="" disabled>Select an Option</option>');
  }
  else {
    $("label[for*='option-1'], label[for*='option-2']").hide();
    $select1.hide();
    $select2.hide();
    $select0.prepend('<option value="" disabled selected>Select an Option</option>');
  }

  // Options to hide for diode-friendly mode
  // Dropdown 1 options to remove if not diode friendly
    const $nonDiodeFriendly0 = $select0.find("option[value='Mirror Acrylic'], option[value='1/8\" & 1/16\" Mirror Acrylic'], option[value='1/8\" Cosmic Kisses'], option[value='1/8\" Neon Acrylic'], option[value='1/8\" Solar Flare Acrylic'], option[value='1/8\" Standard Glitter Acrylic'], option[value='Clear Acrylic'], option[value='1/8\" Clear Acrylic'], option[value='1/8\" White Acrylic'], option[value='1/8\" Frosted Clear']");
    // Dropdown 2 options to remove if not diode friendly
    const $nonDiodeFriendly1 = $select1.find("option[value='White'], option[value='Clear'], option[value='Aqua'], option[value='Blue'], option[value='Golden Yellow'], option[value='Ivory'], option[value='Orange'], option[value='Turquoise'], option[value='Silver Mirror'], option[value='Matte White'], option[value='Frosted Clear']");

  // Toggle diode-friendly options
  $btn.on("click", function () {
    reattachOptions();

    if (isShowingDiodeFriendly) {
      // Reset
      isShowingDiodeFriendly = false;
      $btn.removeClass("button-df").text("SHOW ME DIODE FRIENDLY OPTIONS");
      $txt.show();
      $nonDiodeFriendly0.prop("disabled", false).show();
      $nonDiodeFriendly1.prop("disabled", false).show();
    } else {
      // Enable diode-friendly mode
      isShowingDiodeFriendly = true;
      $btn.addClass("button-df").text("SHOWING DIODE FRIENDLY OPTIONS");
      $txt.hide();

      if ($nonDiodeFriendly0.is(":selected")) {
        $select0.find("option:enabled").not($nonDiodeFriendly0).first().prop("selected", true);
      }
      $nonDiodeFriendly0.prop("disabled", true).hide();

      if ($nonDiodeFriendly1.is(":selected")) {
        $select1.find("option:enabled").not($nonDiodeFriendly1).first().prop("selected", true);
      }
      $nonDiodeFriendly1.prop("disabled", true).hide();
    }

    // Fire Shopify’s change event
    setTimeout(() => {
      $select0[0].dispatchEvent(new Event("change", { bubbles: true }));
    }, 50);

    detachOptions();
  });

  // When option-0 changes, reveal option-1 and option-2
  $select0.on("change", function () {
    if ($select0.val() !== null) {
      $select1.show();
      $select2.show();
      $("label[for*='option-1'], label[for*='option-2']").show();
    }
    reattachOptions();
    detachOptions();
    hideOptionOneDiodeFriendly();
	  sortDisabledToBottom();	
  });

  // When option-1 changes, refresh option-2
  $select1.on("change", function () {
    $detachedOptions2 = $select2.find("option").show();
    $detachedOptions2 = $select2.find("option:disabled").hide();
	  //sortDisabledToBottom();
  });

  // Helpers
  function reattachOptions() {
    $detachedOptions1 = $select1.find("option").show();
    $detachedOptions2 = $select2.find("option").show();
  }

  function detachOptions() {
    $detachedOptions1 = $select1.find("option:disabled").hide();
    $detachedOptions2 = $select2.find("option:disabled").hide();
  }

  function hideOptionOneDiodeFriendly() {
    if(isShowingDiodeFriendly){
      console.log('hide option 1');
      if ($nonDiodeFriendly1.is(":selected")) {
        $select1.find("option:enabled").not($nonDiodeFriendly1).first().prop("selected", true);
      }
      $nonDiodeFriendly0.prop("disabled", true).hide();
      $nonDiodeFriendly1.prop("disabled", true).hide();
    }
  }
  
  function sortDisabledToBottom() {
    const $options = $select1.find("option");

    const enabled = $options.filter(function () { return !this.disabled; });
    const disabled = $options.filter(function () { return this.disabled; });

    // Re-append in order: enabled → disabled
    $select1.empty().append(enabled).append(disabled);
}

});
